import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAppSelector, useAppDispatch } from "./store/hooks";
import { selectIsAdmin, checkAuth } from "./store/authSlice";
import { ToastProvider } from "./components/ToastContainer";

const UserView = React.lazy(() => import("./pages/UserView"));
const AdminView = React.lazy(() => import("./pages/AdminView"));
const AdminLogin = React.lazy(() => import("./pages/AdminLogin"));
const ReadmeView = React.lazy(() => import("./pages/ReadmeView"));
const NotFound = React.lazy(() => import("./pages/NotFound"));

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(selectIsAdmin);

  // 检查身份验证状态
  React.useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <ToastProvider>
      <Router>
        {/* 規範: 應用 "基礎背景" 和 "主要文字" 顏色 */}
        <div className="min-h-screen bg-gray-900 text-gray-200">
          <React.Suspense
            fallback={
              <div className="flex justify-center items-center h-screen">
                加载中...
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<UserView />} />
              <Route
                path="/admin"
                element={
                  isAdmin ? <AdminView /> : <Navigate to="/admin-login" />
                }
              />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/readme" element={<ReadmeView />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" />} />
            </Routes>
          </React.Suspense>
        </div>
      </Router>
    </ToastProvider>
  );
};

export default App;
